module.exports = __webpack_public_path__ + "img/trophy_rank3.5516eef0.svg";